module.exports = __webpack_public_path__ + "static/media/p12.5c1372c7.jpg";